"use strict"

import React from "react"

import { stringifyDate } from "../utils"

export default function DateInputField({ value, valChange, disabled, label = null, style = {} }) {
  return (
    <div style={style}>
      {label && (
        <label
          className={"text-nowrap"}
          style={{ marginRight: "5px", alignContent: "center" }}
        >{`${label}:`}</label>
      )}
      <input
        type={"date"}
        className={"form-control form-control-sm"}
        value={stringifyDate(value, false) || ""}
        style={{
          color: !value ? "var(--lanzalake-red)" : "var(--lanzalake-black)",
        }}
        disabled={disabled}
        onChange={(e) => {
          e.preventDefault()
          e.target.value && valChange(`${e.target.value}T00:00:00`) // Adding T00:00:00 to string to make Date constructor recognize as local date (the default behavior is to assume UTC on a passed YYYY-mm-dd string)
        }}
      />
    </div>
  )
}
